import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './Brick.module.css';

const SERIES_ID = '9710';

export default function Brick({ 
    surfaceName = 'Brick', 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const selectionKey = `Brick_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedProduct(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        
        console.log('Brick - Product selected:', product.color || product.name);
        console.log('Brick - Applying to surface:', surfaceName);
        
        dispatch(selectProduct({
            product,
            surfaceName,
            stepIndex,
            selectionKey
        }));
        
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('Brick - chamViz element not found');
            return;
        }

        if (!product.id) {
            console.error('Brick - Product has no ID');
            return;
        }

        console.log('Brick - Applying product ID:', product.id);
        dispatch(setVizLoading(true));
        
        chamViz.applyByFilter(
            product.id,
            "",
            function(newSel) {
                if (this.name === "Brick") {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Brick"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={onViewAllApplied}
            />

            <div className={styles.productListContainer}>
                <ProductList
                    seriesId={SERIES_ID}
                    thumbSize="256"
                    onProductSelect={handleProductSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedProduct?.id}
                />
            </div>
        </div>
    );
}

Brick.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
